import { CHAT_TOOL_LABELS } from './chatToolLabels';

const LABEL_VERB_PREFIX =
  /^(Reading|Checking|Looking for|Writing|Locating|Detecting|Searching|Finding|Saving|Building|Grouping|Ignoring|Unignoring|Moving|Restoring) /i;

const SHORT_GENERIC_NAMES = new Set(['read', 'write', 'grep', 'glob', 'shell']);

const TOOLISH_NAME =
  /\b(?:get|list|find|search|export|create|save|lookup|detect|ignore|unignore|recycle|restore|summarize|read|write|run|edit)_[a-z0-9]+(?:_[a-z0-9]+)*\b/gi;

const NAMED_TOOLS = Object.keys(CHAT_TOOL_LABELS)
  .filter((name) => name.includes('_') && !SHORT_GENERIC_NAMES.has(name))
  .sort((a, b) => b.length - a.length);

const escapeRegExp = (value: string): string =>
  value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const phraseForTool = (name: string): string => {
  const label = CHAT_TOOL_LABELS[name];
  if (!label) return 'that';
  const trimmed = label.replace(LABEL_VERB_PREFIX, '').trim();
  return trimmed || 'that';
};

const collapseSpaces = (text: string): string =>
  text
    .replace(/[ \t]{2,}/g, ' ')
    .replace(/ +\n/g, '\n')
    .trim();

/**
 * Strips internal function/tool names from DJ-facing chat text.
 * Progress lines that already use labels are left alone.
 */
export const stripToolNamesFromReply = (text: string): string => {
  if (!text) return text;

  let next = text;
  for (const name of NAMED_TOOLS) {
    const phrase = phraseForTool(name);
    const wrapped = new RegExp(`\`${escapeRegExp(name)}\``, 'gi');
    next = next.replace(wrapped, phrase);
    const bare = new RegExp(`\\b${escapeRegExp(name)}\\b`, 'gi');
    next = next.replace(bare, phrase);
  }

  next = next.replace(/`([^`]+)`/g, (_match, inner: string) => {
    TOOLISH_NAME.lastIndex = 0;
    if (TOOLISH_NAME.test(inner)) return 'that';
    return `\`${inner}\``;
  });

  TOOLISH_NAME.lastIndex = 0;
  next = next.replace(TOOLISH_NAME, 'that');
  return collapseSpaces(next);
};
